import type { ImportErrorRow } from '../api';

/** Byte order mark so that Excel reads the UTF-8 umlauts. */
const BOM = String.fromCharCode(0xfeff);

/** CSV of the skipped rows („Fehlerliste herunterladen"): UTF-8 with BOM and semicolons for Excel. */
export function importErrorsCsv(rows: readonly ImportErrorRow[]): string {
  const cell = (value: string | number): string => {
    const text = String(value);
    return /[";\r\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
  };
  const lines = ['Zeile;Name;Telefon;Grund'];
  for (const row of rows) lines.push([row.rowNumber, row.name, row.phone, row.reason].map(cell).join(';'));
  return `${BOM}${lines.join('\r\n')}\r\n`;
}

/** Saves the error list as `<Datei>-Fehlerliste.csv`. */
export function downloadImportErrors(fileName: string, rows: readonly ImportErrorRow[]): void {
  const base = fileName.replace(/\.(xlsx|csv|txt)$/i, '');
  const blob = new Blob([importErrorsCsv(rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `${base}-Fehlerliste.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
